//***********Accessibility Code****************
var help_sbmne = document.querySelectorAll(".Help li a");
help_sbmne.forEach((hlp_btn) => {
  hlp_btn.removeAttribute("role");
  hlp_btn.removeAttribute("aria-level");
});

var newss = document.querySelectorAll(".ctsm_headinglink");
newss.forEach(ggElement => {
if(ggElement.classList.contains("submenu_active")) {
var childlinks = document.querySelectorAll(".ctsm_headinglink_child"); 
childlinks.forEach(chilss => {
chilss.classList.remove("submenu_child_active");
chilss.removeAttribute("aria-current","page");
  });
}
});

  var newssst = document.querySelector("#mob_navbtn");
  newssst.addEventListener("click",function(){
  helss.removeAttribute("tab-index");  
  setTimeout(function(){
  var helss = document.querySelector("#sidebar-menu");
  helss.setAttribute("tab-index","1");  
  helss.setAttribute("aria-label","GEETA GEETAAAA");  
  },100);
  });

document.getElementById('mob_navbtn').addEventListener('click', function () {
  setTimeout(function () {
    var closeButton = document.querySelector('button.Drawer__Close.Icon-Wrapper--clickable');
    if (closeButton) {
      closeButton.focus();
    }
  }, 200);
});

document.querySelector('button.Drawer__Close.Icon-Wrapper--clickable').addEventListener('click', function () {
  setTimeout(function () {
    var navBtn = document.getElementById('mob_navbtn');
    if (navBtn) {
      navBtn.focus();
    }
  }, 200);
});

 
  
const navItems = document.querySelector(".Categories .Heading");
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    
      navItems.setAttribute("aria-expanded", "false")
      const HorizontalList__Item= navItems.parentElement;
      HorizontalList__Item.classList.remove("is-expanded")
   const megaM = HorizontalList__Item.querySelector(".MegaMenu")
      const currentAria = megaM.getAttribute("aria-hidden")
      if (currentAria === "false"){
        megaM.setAttribute("aria-hidden","true")
      }
    
  }
});

 document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    const helpp = document.querySelectorAll(".Help .Heading");

    helpp.forEach((item) => {
      item.setAttribute("aria-expanded", "false");
      const HorizontalList__Item = item.parentElement;
      HorizontalList__Item.classList.remove("is-expanded");
      const megaM = HorizontalList__Item.querySelector(".MegaMenu");
      const currentAria = megaM.getAttribute("aria-hidden");
      if (currentAria === "false") {
        megaM.setAttribute("aria-hidden", "true");
      }
    // const activeElement = document.activeElement;
    const megaMenuTitles = document.querySelectorAll(".Help .MegaMenu__Title");
    megaMenuTitles.forEach((item) => {
      if (item === document.activeElement) {
        document.querySelector(".Help .Heading").focus();
      
      }
    });


      
    });
  }
});
  

  const hamburgerLine= document.querySelector(".Header__FlexItem  #mob_navbtn")
  hamburgerLine.addEventListener("click",function(){
    setTimeout(()=>{
        document.querySelector("#sidebar-menu").setAttribute("tabindex", "1")
    },0)
  
  })


  document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll(".escbtn").forEach((item) => {
      if (item === document.activeElement) {
        let main_Shopp = document.querySelector(".Categories .cstm_submenubtn");
        main_Shopp.focus();
      }
    });
  }
});
  
document.querySelector(".Help").addEventListener("click",function(){
  const helpBtn = document.querySelectorAll(".Help .ctsm_inner_submneu .MegaMenu__Title");
helpBtn.forEach((item) => {
  item.removeAttribute("aria-expanded");
});
})

  document.addEventListener("DOMContentLoaded", function() {
  document.querySelector(".Help .cstm_submenubtn").removeAttribute("aria-current");
});

//***********for Mobile****************

var current_anchors = document.querySelectorAll(".SidebarMenu__Nav a");
current_anchors.forEach((all_anchors)=>{
//code for anchor href path 
var href = all_anchors.getAttribute('href'); // Get the href attribute value
var url = new URL(href, window.location.href);
var anhcor_pathname = url.pathname; 
  
//code for page path 
var page_pathname = window.location.pathname;
if(anhcor_pathname == page_pathname){
all_anchors.setAttribute("aria-current","page");
all_anchors.classList.add("active_nav_item");
}
});

var active_mob_items = document.querySelectorAll(".inner-collapsible a.active_nav_item")

